module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages"
  }, [_c('sub-ibox-title', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.params.id ? '编辑关键词' : '新增关键词'))])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "fx fx-y-center w400"
  }, [_c('p', {
    staticClass: "w60"
  }, [_vm._v("关键词：")]), _vm._v(" "), _c('p', {
    staticClass: "fx-fill"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.keyWords),
      expression: "keyWords",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "maxlength": "20",
      "type": "text",
      "placeholder": "请输入关键词,关键词输入完成敲击回车"
    },
    domProps: {
      "value": (_vm.keyWords)
    },
    on: {
      "blur": [_vm.handleInputKeyWords, function($event) {
        return _vm.$forceUpdate()
      }],
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleInputKeyWords($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyWords = $event.target.value.trim()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "keywords-content"
  }, [_c('div', {
    staticClass: "key-list m-t-5"
  }, [_c('ol', {
    staticClass: "fx fx-wrap"
  }, _vm._l((_vm.keyWordsArr), function(item, index) {
    return _c('li', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(item) + "\n\t\t\t\t\t\t"), _c('em', {
      staticClass: "icon-del",
      on: {
        "click": function($event) {
          return _vm.handleDelInputKeyWords(index)
        }
      }
    })])
  }), 0)]), _vm._v(" "), _c('section', {
    staticClass: "m-t-15"
  }, [_c('z-radio-material', {
    attrs: {
      "radio-bar-params": _vm.radioBarParams,
      "is-layer-material": _vm.isLayerMaterial
    },
    on: {
      "cancelMaterialLayer": _vm.cancelMaterialLayer,
      "handleClickRadioBar": _vm.handleClickRadioBar,
      "handleSetContent": _vm.handleSetContent
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-t-20"
  }, [_c('a', {
    staticClass: "z-btn z-btn-primary b-r-3",
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("保存")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-5e859b25","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/wechat/WxKeyWordsEdit.vue
// module id = 855
// module chunks = 0